import {
  FIRST_NAME_DATA_STANDARDS,
  LAST_NAME_DATA_STANDARDS,
} from 'jl-design-system/form/fields';
import getAddressFieldsConfig from 'jl-design-system/form/configs/address';
import {
  countryCodeIsInternational,
} from '../../address/addressHelpers';
import getInternationalPhoneNumberConfig from '../../lazy/internationalPhoneNumberConfig';

import makePostcodeOptional from '../../address/makePostcodeOptional';

export const GOOGLE_PAY_BILLING_ADDRESS_FORM_ID = 'googlePayBillingDetailsForm';
export default function getGooglePayBillingDetailsFormConfig(params) {

  const {
    countryCode,
    addressLines = 3,
    maxAddressLines,
    actions,
    configExtras,
    international,
    enableGBCounty,
  } = params;

  const {
    isClickCollectOrder,
    submitButtonExtra,
  } = configExtras;

  const ADDRESS_FIELDS = getAddressFieldsConfig({
    international,
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    allowAsciiOnly: true,
    enableGBCounty,
  });

  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    isClickCollectOrder,
    showDefaultInstruction: true,
  });

  const postcodeOptional = countryCodeIsInternational(countryCode);
  if (postcodeOptional) {
    makePostcodeOptional(ADDRESS_FIELDS);
  }

  return {
    submitButton: 'Continue with payment',
    submitButtonExtra,
    id: GOOGLE_PAY_BILLING_ADDRESS_FORM_ID,
    fields: [
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      PHONE_NUMBER,
      ...ADDRESS_FIELDS,
    ],
  };
}
